// An empty canvas's first screen (Features 4, part 3): the empty card, centred on the room beside the chat, while
// the board has nothing on it.

import { Plus } from "lucide-react";
import { boardItems, set, useStore } from "../state/store";
import { EmptyKind } from "./EmptyKind";

export function CanvasEmpty() {
  const empty = useStore((s) => !!s.boardId && boardItems(s, s.boardId).length === 0);
  const shown = useStore((s) => !s.presentIds && !s.panel);
  if (!empty || !shown) return null;
  return (
    <div className="ob-empty-place is-canvas">
      <EmptyKind kind="canvas" byHand={{ label: "Add a widget", icon: <Plus size={14} />, kbd: "A", run: () => set({ panel: "gallery", panelArg: null }) }} />
    </div>
  );
}
